// extracted by mini-css-extract-plugin
export default {"imgsContainer":"Scroller_imgsContainer__m4vGy"};